import type { CatalogueCounty } from './types.js';

// U.S. Census Bureau TIGERweb ACS25 county catalogue.
export const KENTUCKY_COUNTIES: readonly CatalogueCounty[] = [
  { name: "Adair", state: "KY", fips: "21001" },
  { name: "Allen", state: "KY", fips: "21003" },
  { name: "Anderson", state: "KY", fips: "21005" },
  { name: "Ballard", state: "KY", fips: "21007" },
  { name: "Barren", state: "KY", fips: "21009" },
  { name: "Bath", state: "KY", fips: "21011" },
  { name: "Bell", state: "KY", fips: "21013" },
  { name: "Boone", state: "KY", fips: "21015" },
  { name: "Bourbon", state: "KY", fips: "21017" },
  { name: "Boyd", state: "KY", fips: "21019" },
  { name: "Boyle", state: "KY", fips: "21021" },
  { name: "Bracken", state: "KY", fips: "21023" },
  { name: "Breathitt", state: "KY", fips: "21025" },
  { name: "Breckinridge", state: "KY", fips: "21027" },
  { name: "Bullitt", state: "KY", fips: "21029" },
  { name: "Butler", state: "KY", fips: "21031" },
  { name: "Caldwell", state: "KY", fips: "21033" },
  { name: "Calloway", state: "KY", fips: "21035" },
  { name: "Campbell", state: "KY", fips: "21037" },
  { name: "Carlisle", state: "KY", fips: "21039" },
  { name: "Carroll", state: "KY", fips: "21041" },
  { name: "Carter", state: "KY", fips: "21043" },
  { name: "Casey", state: "KY", fips: "21045" },
  { name: "Christian", state: "KY", fips: "21047" },
  { name: "Clark", state: "KY", fips: "21049" },
  { name: "Clay", state: "KY", fips: "21051" },
  { name: "Clinton", state: "KY", fips: "21053" },
  { name: "Crittenden", state: "KY", fips: "21055" },
  { name: "Cumberland", state: "KY", fips: "21057" },
  { name: "Daviess", state: "KY", fips: "21059" },
  { name: "Edmonson", state: "KY", fips: "21061" },
  { name: "Elliott", state: "KY", fips: "21063" },
  { name: "Estill", state: "KY", fips: "21065" },
  { name: "Fayette", state: "KY", fips: "21067" },
  { name: "Fleming", state: "KY", fips: "21069" },
  { name: "Floyd", state: "KY", fips: "21071" },
  { name: "Franklin", state: "KY", fips: "21073" },
  { name: "Fulton", state: "KY", fips: "21075" },
  { name: "Gallatin", state: "KY", fips: "21077" },
  { name: "Garrard", state: "KY", fips: "21079" },
  { name: "Grant", state: "KY", fips: "21081" },
  { name: "Graves", state: "KY", fips: "21083" },
  { name: "Grayson", state: "KY", fips: "21085" },
  { name: "Green", state: "KY", fips: "21087" },
  { name: "Greenup", state: "KY", fips: "21089" },
  { name: "Hancock", state: "KY", fips: "21091" },
  { name: "Hardin", state: "KY", fips: "21093" },
  { name: "Harlan", state: "KY", fips: "21095" },
  { name: "Harrison", state: "KY", fips: "21097" },
  { name: "Hart", state: "KY", fips: "21099" },
  { name: "Henderson", state: "KY", fips: "21101" },
  { name: "Henry", state: "KY", fips: "21103" },
  { name: "Hickman", state: "KY", fips: "21105" },
  { name: "Hopkins", state: "KY", fips: "21107" },
  { name: "Jackson", state: "KY", fips: "21109" },
  { name: "Jefferson", state: "KY", fips: "21111" },
  { name: "Jessamine", state: "KY", fips: "21113" },
  { name: "Johnson", state: "KY", fips: "21115" },
  { name: "Kenton", state: "KY", fips: "21117" },
  { name: "Knott", state: "KY", fips: "21119" },
  { name: "Knox", state: "KY", fips: "21121" },
  { name: "Larue", state: "KY", fips: "21123" },
  { name: "Laurel", state: "KY", fips: "21125" },
  { name: "Lawrence", state: "KY", fips: "21127" },
  { name: "Lee", state: "KY", fips: "21129" },
  { name: "Leslie", state: "KY", fips: "21131" },
  { name: "Letcher", state: "KY", fips: "21133" },
  { name: "Lewis", state: "KY", fips: "21135" },
  { name: "Lincoln", state: "KY", fips: "21137" },
  { name: "Livingston", state: "KY", fips: "21139" },
  { name: "Logan", state: "KY", fips: "21141" },
  { name: "Lyon", state: "KY", fips: "21143" },
  { name: "McCracken", state: "KY", fips: "21145" },
  { name: "McCreary", state: "KY", fips: "21147" },
  { name: "McLean", state: "KY", fips: "21149" },
  { name: "Madison", state: "KY", fips: "21151" },
  { name: "Magoffin", state: "KY", fips: "21153" },
  { name: "Marion", state: "KY", fips: "21155" },
  { name: "Marshall", state: "KY", fips: "21157" },
  { name: "Martin", state: "KY", fips: "21159" },
  { name: "Mason", state: "KY", fips: "21161" },
  { name: "Meade", state: "KY", fips: "21163" },
  { name: "Menifee", state: "KY", fips: "21165" },
  { name: "Mercer", state: "KY", fips: "21167" },
  { name: "Metcalfe", state: "KY", fips: "21169" },
  { name: "Monroe", state: "KY", fips: "21171" },
  { name: "Montgomery", state: "KY", fips: "21173" },
  { name: "Morgan", state: "KY", fips: "21175" },
  { name: "Muhlenberg", state: "KY", fips: "21177" },
  { name: "Nelson", state: "KY", fips: "21179" },
  { name: "Nicholas", state: "KY", fips: "21181" },
  { name: "Ohio", state: "KY", fips: "21183" },
  { name: "Oldham", state: "KY", fips: "21185" },
  { name: "Owen", state: "KY", fips: "21187" },
  { name: "Owsley", state: "KY", fips: "21189" },
  { name: "Pendleton", state: "KY", fips: "21191" },
  { name: "Perry", state: "KY", fips: "21193" },
  { name: "Pike", state: "KY", fips: "21195" },
  { name: "Powell", state: "KY", fips: "21197" },
  { name: "Pulaski", state: "KY", fips: "21199" },
  { name: "Robertson", state: "KY", fips: "21201" },
  { name: "Rockcastle", state: "KY", fips: "21203" },
  { name: "Rowan", state: "KY", fips: "21205" },
  { name: "Russell", state: "KY", fips: "21207" },
  { name: "Scott", state: "KY", fips: "21209" },
  { name: "Shelby", state: "KY", fips: "21211" },
  { name: "Simpson", state: "KY", fips: "21213" },
  { name: "Spencer", state: "KY", fips: "21215" },
  { name: "Taylor", state: "KY", fips: "21217" },
  { name: "Todd", state: "KY", fips: "21219" },
  { name: "Trigg", state: "KY", fips: "21221" },
  { name: "Trimble", state: "KY", fips: "21223" },
  { name: "Union", state: "KY", fips: "21225" },
  { name: "Warren", state: "KY", fips: "21227" },
  { name: "Washington", state: "KY", fips: "21229" },
  { name: "Wayne", state: "KY", fips: "21231" },
  { name: "Webster", state: "KY", fips: "21233" },
  { name: "Whitley", state: "KY", fips: "21235" },
  { name: "Wolfe", state: "KY", fips: "21237" },
  { name: "Woodford", state: "KY", fips: "21239" },
];
